<script setup lang="ts">
  import { useStorage } from '@vueuse/core'
  import { cva } from 'class-variance-authority'

  const props = defineProps<{ url: string; title: string; slug: string }>()

  const localOfferStorage = useStorage<string[]>('localOfferStorage', [])

  const emit = defineEmits(['onUpdate'])
  const offerSlug = computed(() => props.slug)
  const offerLink = computed(() => props.url)
  const offerTitle = computed(() => props.title)

  const updateSelectedOffer = (secondaryClick = false) => {
    emit('onUpdate', offerSlug.value, offerLink.value, secondaryClick)
  }

  const isOfferVisited = computed(() => localOfferStorage.value.includes(offerSlug.value))

  const isOfferVisitedBase = computed(() =>
    cva('', {
      variants: {
        isOfferVisited: {
          true: 'font-normal text-secondary',
          false: 'font-medium text-subtitle-1'
        }
      }
    })({
      isOfferVisited: isOfferVisited.value
    })
  )
</script>
<template>
  <div class="flex justify-between">
    <a
      class="flex flex-col no-underline"
      :href="offerLink"
      @click.prevent="updateSelectedOffer()"
      @auxclick="updateSelectedOffer(true)"
    >
      <div :class="isOfferVisitedBase">
        {{ offerTitle }}
      </div>
      <div class="mt-2 text-xs font-normal leading-4 text-link">
        {{ $t('readMore') }}
      </div>
    </a>
  </div>
</template>
